<nz-avatar [nzSize]="size"  style="font-size:{{fontSize}}px;" [nzText]="text"></nz-avatar>
